module.exports = __webpack_public_path__ + "static/media/flock_logo.6af77532.png";